import SuiCompetitionStageSelect from './competition/SuiCompetitionStageSelect.vue'
import SuiCompetitionMatchSelect from './competition/SuiCompetitionMatchSelect.vue'
import SuiCompetitionSessionSelect from './competition/SuiCompetitionSessionSelect.vue'

export default {
  SuiCompetitionStageSelect,
  SuiCompetitionMatchSelect,
  SuiCompetitionSessionSelect
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/components/business/index.js